import type {ReactNode} from 'react'
import {addMaybeClassName} from '@freckle/educator-entities/ts/common/helpers/classnames'
import type {BreadcrumbsProps} from '@freckle/educator-materials/ts/components/breadcrumbs'
import {PageHeader} from '@freckle/educator-materials/ts/components/page-header'
import {childrenWrapper} from './page-wrapper.module.scss'

type Props = {
  title?: string
  breadcrumbsConfig?: BreadcrumbsProps | null
  children: ReactNode
  addPageWrapperContainerClass?: string | null
}

export function PageWrapper(props: Props) {
  const {title, breadcrumbsConfig, children, addPageWrapperContainerClass} = props
  const containerClassName = addMaybeClassName(childrenWrapper, addPageWrapperContainerClass)
  return (
    <>
      <PageHeader title={title} breadcrumbsConfig={breadcrumbsConfig} />
      <div className={containerClassName}>{children}</div>
    </>
  )
}
